import PropTypes from 'prop-types';

import assert from 'assert';

import objectToGetParams from './utils/objectToGetParams';
import createShareButton from './utils/createShareButton';

function viberLink(url, _ref) {
  var title = _ref.title;

  assert(url, 'viber.url');
  return 'viber://forward' + objectToGetParams({
    text: (title || '') + ' ' + url
  });
}

var ViberShareButton = createShareButton('viber', viberLink, function (props) {
  return {
    title: props.title
  };
}, {
  title: PropTypes.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

export default ViberShareButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-share/es/ViberShareButton.js
// module id = 1696
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 20 21